import { createContext, type ReactNode, useContext, useState } from 'react';
import { useReportExport } from './hooks/useReportExport';

interface ReportContextValue {
  exportToExcel: () => Promise<void>;
  canExport: boolean;
  queryParams: BanHangRecord | null;
  setQueryParams: (params: BanHangTableParams | null) => void;
  exportSubtitle: string;
  setExportSubtitle: (subtitle: string) => void;
}

const ReportContext = createContext<ReportContextValue | null>(null);

export const useReportContext = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportContext must be used within ReportContext');
  }
  return context;
};

export const ReportProvider = ({ children }: { children: ReactNode }) => {
  const [queryParams, setQueryParams] = useState<BanHangRecord | null>(null);
  const [exportSubtitle, setExportSubtitle] = useState('');
  const { exportToExcel, canExport } = useReportExport(queryParams);

  return (
    <ReportContext.Provider
      value={{
        exportToExcel,
        canExport,
        queryParams,
        setQueryParams,
        exportSubtitle,
        setExportSubtitle
      }}
    >
      {children}
    </ReportContext.Provider>
  );
};
